export default __webpack_public_path__ + "static/media/footer-w@3x.66ca8abe.png";